<template>

    <Toast/>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Account</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Email Lists</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Select which email lists you would like to receive and their frequency.
                </span>
            </div>
        </div>

        <div v-show="activeTab === 1" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="field">
                        <span>Functionality not available with current subscription. Please upgrade to view functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <h4>Select the frequency for the list you would like to subscribe to:</h4>

                    <div class="field">
                        <label for="region">Top Ranked Stocks</label>
                        <Dropdown v-model="userConfiguration.siEmailTopranked" :options="frequencyTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="type">Runners-Up Stocks</label>
                        <Dropdown v-model="userConfiguration.siEmailRunnersup" :options="frequencyTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="requirePhone">Deep Valued Dividend Stocks</label>
                        <Dropdown v-model="userConfiguration.siEmailDeepvalued" :options="frequencyTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="updateConfiguration"></Button>

                </div>
            </div>
        </div>
    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[PhoneCalls][mounted] Data = ", userData);
            console.log("[PhoneCalls][mounted] this.profile = ", this.profile);

            if (this.profile.rights === 'C') {
                this.activeTab = 1;
            } else {
                this.activeTab = 2;
            }

        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        console.log("[PhoneCalls][mounted] this.userConfiguration = ", this.userConfiguration);
    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            userConfiguration: {},
            frequencyTypes: [
                {name: 'Daily (once a day)', code: 'D'},
                {name: 'Weekly (every Saturday)', code: 'W'},
                {name: 'Monthly (every 1st of the month)', code: 'M'},
                {name: 'None', code: 'N'}
            ]
        }
    },
    methods: {
        callOverview() {
            this.$router.push("siOverview");
        },
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        async updateConfiguration() {

            var updatedConfiguration = {
                siEmailTopranked: this.userConfiguration.siEmailTopranked,
                siEmailRunnersup: this.userConfiguration.siEmailRunnersup,
                siEmailDeepvalued: this.userConfiguration.siEmailDeepvalued
            };

            console.log("[ConfigurationEmailLists][updateConfiguration] Updated configuration. Data = ", updatedConfiguration);

            try {
                // Delete the appointment
                const response = await UserService.updateUserConfig(this.userStore.user.id, updatedConfiguration);
                console.log('[ConfigurationEmailLists][updateConfiguration] Response = ', response);

                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (e) {
                console.error('[ConfigurationEmailLists][updateConfiguration] Error:', e);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
